import api from '~/api';
import { UserResponse, UserStatusResponse } from '../dtos/usersResponse';
import { User, UserStatus } from '../models/users.model';

const StatusMap: Record<UserStatusResponse, UserStatus> = {
  active: 'Active',
  inactive: 'Inactive',
};

interface EditUserPayload {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
}

export async function editUser(
  partnerId: string,
  userId: string,
  payload: EditUserPayload
): Promise<User> {
  const { data } = await api.post<UserResponse>(`v1/partner/${partnerId}/partner_user/${userId}`, {
    first_name: payload.firstName,
    last_name: payload.lastName,
    email: payload.email,
    phone_number: payload.mobileNumber,
  });
  return new User(
    data.id,
    data.first_name,
    data.last_name,
    data.email,
    data.phone_number,
    StatusMap[data.status]
  );
}
